<template>
  <SessionWrapper>
    <ViewpointsPathway v-bind="props" />
  </SessionWrapper>
</template>

<script setup lang="ts">
import SessionWrapper from "../../components/sessions/session-wrapper.vue";
import ViewpointsPathway from "./viewpoints-pathway.vue";
import { InviteControlApiModel, SessionsApiModel } from "../../api-models";

const props = defineProps<{
  sessionsModel: SessionsApiModel;
  inviteControlModel: InviteControlApiModel;
}>();
</script>
